import axios from 'axios'
import { host } from '../../../helper/config'
import { FULL_LIST_ITEM_PER_PAGE, getItemPerPage } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-loto-tickets'

export const updateTicketImages = async (token, ticketId, images) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-images`, {
        ticketId,
        images,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const cancelLotoTicket = async (token, ticketId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/cancel-refund`, {
        ticketId,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const cancelLotoCart = async (token, cartId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/cancel-refund`, {
        cartId,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getSearchCsv = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/search-csv`, {
        ...query,
        page: page,
        itemPerPage: FULL_LIST_ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const searchTicket = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/search-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
